export interface INotificationData {
    titleKey?: string;
    descriptionKey: string;
}
